<template>
  <div id="huanzaijin">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>還債金</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/products">产品</router-link>
            </li>
            <li class="breadcrumb-item active">還債金</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-project">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="project-img">
                <img
                  :src="require('@/assets/img/products/huan-zai-jin.jpg')"
                  class="img-res mx-auto"
                  alt=""
                />
              </div>
              <!-- /.project-img -->
            </div>
            <aside class="col-md-12">
              <div class="project-info text-justify">
                <h5>『還債金』</h5>

                <p class="project-description">
                  相传唐朝泾河龙王为了算命先 生打赌下雨之事，犯了天条
                  ，玉帝下令曹官魏徵斩龙王，龙 王只有求助唐王太宗救他一命，
                  可惜唐太宗不知魏徵可以灵魂 出窍，只找魏徵下棋，下棋时-
                  魏徵睡了, 灵魂上天门处斩龙王I ，龙王认为唐太宗没有实现诺
                  言，变鬼将唐太宗吓死，在临 死前魏徵交了一封信给唐太宗
                  ，说，只要交到判官的手，就 可以还阳，唐太宗接过后断气了。
                </p>

                <p class="project-description">
                  话说唐太宗到了阎王殿前，见到 判官崔狂，唐太宗立刻将魏徵之书信
                  交上。判官一边看一边带路，到达森
                  罗殿上，见到十殿阎王，唐太宗将事
                  件道出，阎王命判官取生死簿，检查
                  唐太宗阴寿，判官替]唐太宗加了二划
                  ，将一变三，十殿阎王一看，还有二
                  十年命，立刻命判官送唐太宗还阳。
                </p>

                <p class="project-description">
                  李世民辞别了十殿阎王之秦广王 ，路过枉死城，冤鬼前来索命，只有
                  由判官崔珏担保，借用了河南开封府
                  ，编草鞋匠相良老夫妇所寄存的库钱
                  ，散发给枉死城内的孤魂野鬼，还答
                  应返回阳世之后，举办法会替他们超
                  渡。这一趟「地府之旅」，让李世民
                  积了不少阴德，也让他多享受了二十
                  年的帝王生活。人死变鬼，鬼入轮迴
                  ，而投身六界。这是人生的终点。多
                  少人捧着一腔血茫而来，多少不甘愿
                  也只能化做一回眸。过奈何桥，喝孟
                  婆汤，六道轮迴之后是冤屈的第一生
                  啼哭，三生石上，又被刻下深深一笔
                  ，记下该了的债，该还的债……太宗
                  由于他没喝过孟婆汤，所以还能记起
                  ，但是阴间的事，为了要还那一笔库
                  黄金。太宗立即下诏大赦天下，广召
                  髙僧，髙僧施法为死者作金银纸钱还债，并且製定焚烧纸钱的法要。可惜
                  人已记不起投胎之前的鬼债，变成一
                  个赖账人，于是，来到人间给鬼纠缠 不清，触尽霉头。
                </p>

                <p class="project-description">
                  一世倒霉也搞不清楚为什麽？正 所谓，无债一身轻，鬼债更欠不得。
                  虽然许多人也烧了很多金银给阴人，
                  不过，那些鬼债主却得不到，变成毫 无作角。
                </p>

                <p class="project-description">
                  金银纸也由此传开，所以一到神 鬼时节，街头巷尾，到处可见人们在
                  烧「金银纸」，这就是“冥纸”。金
                  银纸的历史也由此而来。民间对神灵
                  的祭拜，焚香烛烧金银纸，是不可缺
                  少的祭仪，藉香烛与神灵沟通，其中
                  没有还债金，在祭祀时焚化以前或未
                  投胎之前所欠下的债，却无法归还了 结。
                </p>

                <p class="project-description">
                  正所谓欠债还钱，天地良心。前 世债今生还，也一样无愧于真理。若
                  以平常心来看待一个人被别人欠了债
                  ，对方已作出了种种赔偿，也许他本
                  身并没有得到，却真实地看到对方的
                  付出，也会感到心慰。鬼是人死后而
                  成的，当牠看到欠牠债的人在还债给
                  牠，即时牠没有得到，心中的怨气也
                  会消掉，心中怨气、冤气一旦消去，
                  于是就可以放得下，安心去投胎转世 ，不必再阴魂不散。
                </p>

                <p class="project-description">
                  人鬼虽隔阴阳，其本质也同，像 世人对佛法的认识，顿悟与觉悟的认
                  知不同。有人可听头知尾，举一反三
                  ；有人却像对牛弹琴，难以明白，非
                  要讲过多遍才懂；几乎要捉着他的手
                  试范才行，像幼儿园学生一样，老师
                  讲一加一等于二，有的孩子立刻明白
                  ，有的却要老师拿着两粒苹果才能暸 解。
                </p>

                <p class="project-description">
                  苗大师发明了还债金的道理也一 样，要让那些无法明白，我们对他的
                  那一份敬意和诚心的阴人，让他们明
                  白我们在清还欠他的债，即时牠不可能得到，也会明白我们是要还债的人
                  ，好让牠们能够放得下而去投胎。讲
                  到投胎必须先讲死亡。人死就是走向
                  不归路，有几人能够放得下就这样走
                  开呢？世人都有私心，鬼也一样有私
                  心，试想一个人只要突然间被派往到
                  一个陌生的地方去，只要时间长一点
                  ，就会想念着自己的家乡，何况，人
                  死后，是要到一个永远不能回来的地 方，怎能那麽容易放得下？
                </p>

                <p class="project-description">
                  人们去逛街、旅游，也只是满足 自己，根本不能拥有它或者把它带回
                  来。就好像烧金银纸和做法事也同样
                  的道理，所不同的是，前者满足活人
                  后者满足亡灵，在九泉之下也能感到 欣慰。
                </p>

                <p class="project-description">
                  以下的是一个真实故事，有一位 富翁死后，孩子们为了父亲的丧礼各
                  执一词。有的说找高僧念经超渡就行
                  了；有的却说要做功德烧大洋房、大
                  汽车、各种电器、女佣、花王、信用
                  卡等等等。在相持之际高僧到来。请
                  高僧的孩子便说：「我们问高僧吧！」
                  高僧听了问题后答道：「只要为 死者诵经就够了。」
                  这时主张大做功德的孩子开声道 :「请问大师，您替我父亲诵经收不
                  收钱？」 高僧答道：「阿弥陀佛！收！不 过，我们只收六百元。」
                  「大师，你是得道高僧也还要收 钱，这表明大师也离不开物质的需求
                  。你知道吗？我父亲只是个庸俗的商
                  人，并非是一个四大皆空的高人，更
                  何况他曾经拥有过那麽多的物质，如
                  今却不给他多一点，怎麽放得下。还
                  有我们做功德烧金烧银，绝对不是做
                  给世人看的。这一切的一切都是在安
                  慰亡灵。世人所做的一切，包括高僧
                  诵经，道士做功德都是在安慰亡灵。
                  换句话说，活人做得心安理得，死者 也放得下去转世投胎。
                </p>

                <p class="project-description">
                  当然像那些得道髙僧与有道之士 ，他们已经顿悟了，离开尘世之后，
                  即使没有超渡，甚麽没有香火，他们
                  一样可以放得下，顺利到达菩萨界。 有一点，一般世人在人间终生都
                  无法追求到金钱物质的满足，死后也
                  不情不愿，很不甘心。在世的阳人为
                  了让阴人那一口怨气、冤气能消失，
                  就会烧大量的物质给他，好让阴人不
                  再埋怨，可以享受放得下的到六道轮
                  迴，去转世为人。即使那些在人间享
                  尽荣华富贵的人，他们一旦离世，同
                  样的因为不能带走阳间财富，也感到
                  非常的不甘心，无法放得下，而成为
                  冤魂厉鬼，这也是非常难过之事。为
                  了让鬼与人都能达到放得下的境界， 烧金银纸。
                </p>

                <p class="project-description">
                  再说即使在阴间没有鬼债，烧了 还债金，也可以像那一对草鞋匠相良
                  夫妇那样，在阴间存下一笔钱，不单
                  死后用得到，来生也可用到，死后不
                  是穷鬼，来生不一定是富人，但肯定 不是“穷鬼”。
                  这也是佛家所说的：放得下。人 放得下可以安心到极乐世界去。鬼放
                  得下时一切冤气都消了，又那裡还有
                  冤魂不散的事呢？还有，人一旦去世
                  ，就甚麽也带不去，只有功德，您做
                  了多少就能带走多少。而且还能作为
                  您的转世为人的食禄寿依剧。金银纸
                  还债金就是让人在世间做功德的证件
                  。所以做功德，与阴人沟通都需要用 到它。
                </p>

                <p class="project-description">
                  <span><b>还债金 消灾解难</b></span>
                  为甚麽事业不顺？ 为甚麽婚姻不美满、不幸福？
                  为甚麽自己的另一半着外遇？ 为甚麽孩子总不听话？
                  为甚麽家裡天天吵吵闹闹？为甚麽生病医不好？ 为甚麽得奇难杂症？
                  为甚麽精神恍惚、脾气暴躁？ 为甚麽会生意外？ 为甚麽没有小孩？
                  为甚麽遭人诽镑？被人排挤？ 这些答桉本书裡可以找到。
                  看了本书，这些问题可以迎刃而解。
                </p>

                <p class="project-description">
                  <span><b>第一章：做善事和烧还债金是两码子事 </b></span>
                  做善事和烧还债金根本是两回事 行善积德 未来有福报 欠别人家的债
                  欠债一定要还 有些人总会觉得，他这辈子已尽
                  力行善，为甚麽还会遭受冤亲债主的
                  报复和折磨？不是善有善报吗？事实
                  上，行善事和烧还债金是两码子事。 做善事，积的是将来的福报。
                  烧还债金，是欠别人的债。 举例来说：
                  您帮过人先生，人先生可能有一 天会来向您报恩，这是积您自己将来
                  的福报。 您害过3先生, 3先生现在向您
                  报仇，您可以因为您以前帮助过八先 生,
                  就和8先生之前的恩怨一笔勾消 吗？ 令答案：不能！
                </p>

                <p class="project-description">
                  <span><b>第二章：种瓜得瓜， 种豆得豆。</b></span>
                  「上天」的奖赏或惩罚即是前世 因果及今世因果。 种善因，得善果。
                  如果我们做善事，上天会根据我 们所做的善事加以评估，然后赐福给
                  我们，这是我们自己种的善果得来的。
                  上天的奖赏是：让我们这辈子命 好、运好、事事顺顺利利……各种好
                  的事情都会心想事成。 种恶因，得恶果。
                  如果我们做恶事，上天会根据我 们所做的恶事加以评估，然后给我们
                  惩罚，这是我们自己种的恶果得来的。
                  上天的惩罚是：让我们这辈子命 苦、贫穷、运滞、多病、做事阻碍重
                  重……一切不顺的事情会发生。 所以，上天是根据我们为善或为
                  恶，而给予我们应得的奖赏或惩罚，
                  这些奖赏或惩罚，事实上都是我们自 己一手造成的。
                  <span><b>「无形界」的报恩或报仇</b></span>
                  除了上天的奖赏或惩罚以外，无 形界的人也会来向我们报恩或报仇。
                  如果我们以前帮助过他，这辈子 他可能会找机会向我们报恩，有些人
                  做事总是逢凶化吉，贵人不绝，就是
                  因为他以前帮助过很多人，这些人前 来报恩了。
                  如果我们以前得罪过他，这辈子 他可能会找机会向我们报仇。所以，
                  有些人做事总是处处碰壁，处处遭受
                  阻碍，甚至遭人诬陷，就是因为他以
                  前得罪过人，这些人前来报仇了。 所以，除了上天的奖赏或惩罚以
                  外，无形界的人也会是来向我们报恩 或报仇。
                  我们帮助过他，有一天，他会来 我们得罪过他，有一天，他会来
                  找我们报仇。
                  <span><b>烧还债金做善事，二份奖赏。</b></span>
                  老天爷奖赏十无形界的絲娜。 美丽、富贵、无病无灾。贵人不
                  绝、逢凶化吉。 所以，种一份因，我们得到的是
                  二份果。种善因，得善果。我们得到的是
                  :上天的奖赏十无形界的报恩。有了
                  这二份奖赏，我们这辈子做什么事都 会顺顺利利。
                  <span><b>做恶事，二份惩罚。</b></span
                  >老天爷惩罸十无形界的絲报仇。 贫穷、多病、多灾多难。处处碰
                  壁、遭遇小人。 种恶因，得恶果。我们得到的是
                  :上天的惩罚十无形界的报仇。 有了这二份惩罚，我们这辈子做
                  什么事都会不顺利。
                  <span><b>冤亲债主报仇的情形 </b></span>
                  冤亲债主八 让您得重病，医生看不好。 冤亲债主8
                  让您事业不顺，财务出问题。 冤亲债主匸
                  让您婚姻不顺，另一半有外遇。 冤亲债主0
                  让您没有孩子（久婚不孕〉。 冤亲债主丑
                  让您子女难教，孩子不听话。 冤亲债主？
                  让您精神恍惚，得出精神病。
                  <span><b>冤亲债主报仇时， 会出现哪些情况？ </b></span>
                  下面的这些情况，可能是（冤亲 债主）报仇来了：
                  事业失败，财务週转不灵，甚至 官司缠身。 身边都是小人。
                  婚姻不顺，夫妻吵架，甚至另一 半有外遇。
                  染上种种恶习，如沉溺赌博、嗜 酒如命……
                  遇人不淑，适婚年龄到了还是结不了婚。
                  精神恍惚，脾气暴躁，口出恶言 秽语。 久婚不孕，没有孩子。
                  得精神病，如精神官能症，精神 分裂症......
                  子女难教，不听话，不孝顺。 奇难杂症。 婴儿得病或难带。
                  久讎愈，医生怎麽治都治不好。 每个人欠的都不一样，每个人要
                  还的也不一样。 运旺时，冤亲债主在旁边等。
                  运低时，冤亲债主就上门讨债了。 当我们运旺时，这些冤亲债主只
                  能在旁边等待机会，伺机而动，等到
                  我们运低时再向我们下手，这时，事
                  业失败、婚姻出现裂痕、财务週转不
                  灵、官司缠身……种种不顺的事，就 会一个接一个到来。
                </p>

                <p class="project-description">
                  <span><b>第三章：债不可能一次 就地还完。</b></span>
                  有这麽多债要还，当然不如意事 ,十之八九0
                  一世，二世，累世欠债四世…… 加加减减目前欠债 这辈子新增加的债
                  这辈子还掉的债 累世欠的债加新增加的债减去已
                  还掉的债等于目前要还的债。 其实我们欠了太多债，我们是不
                  可能一次就还完的。 我们有多少债要还呢？
                  累世欠的债加这辈子新增加的债 减去已还掉的债等于我们目前要还的
                  债。 累世欠的债就是把我们累世欠的
                  债全部加起来，一世、二世、三世、
                  四世、五世……上一世，我们把这些
                  债全部加起来，就是我们累世所欠的 债。
                  因为我们是凡人，这辈子难免会 做错事、得罪人，所以，从出生到现
                  在，我们又可能有累积了一些新债了。
                  所以：累世的债加这辈子新增加 的债减已还掉的债等于目前我们要还
                  的债。 即然我们有这麽多债要还，我们 怎麽可能一次就还清呢？
                  <span><b>持续烧还债金， 改变注定的命。</b></span>
                  (1)命不是那麽容易就可以改变的。 「前世因，今世果」，我们的命
                  是因为前辈子我们为善为恶被判定的
                  结果。不是那麽容易就可以更改的。
                  不过，虽然命已经注定了，但也不是
                  不能更改，要改变我们注定的命，我
                  们可以透过做善事、积功德和烧还债
                  金的方式，我们做的善事够多，积的
                  功德够大，还债金持续烧，老天爷就
                  会赐寿给我们，改变我们注定的命〔 不好的命：！。
                  所以，命不是不能改，命是不容 易改，只有我们持续做善事、积功德
                  和烧还债金，我们才有可能改变我注 定的命。
                  (2)持续烧，继续行善，以改变注
                  定的命所以，要改变注定的命〈不好的
                  命〉，除了做功德以外，还要烧还债
                  金，只要我们持续做功德，焚烧还债
                  金，我们就有机会改变我们不好的命。
                  「人在做，天在看」；「人在做 ，冤亲债主也在看」，只要我们持续
                  做善事、积功德、烧还债金，就算我
                  们本来命该绝的，老天爷、冤亲债主
                  也会放我们一马，所以，这也是为什
                  麽有些人得了奇难杂症，居然莫名其
                  妙好起来，就是因为老天爷和冤亲债 主不惩罚他了。
                  所以，只要我们持续做善事、烧还债金，有一天，老天爷一定会降旨
                  改变我们不好的命。所以易经说：「 积善之家，必有馀庆」。
                  (3)烧还债金 帮自己多存一些「 无形存款」吧！
                  其实我们每个人都有一个「无形 账户」，裡面存的是「无形存款」。
                  我们做了善事时，这个账户裡的 「存款」就会增加一笔，我们做的善
                  事越多，账户裡的存款也就越多。
                  我们做错事时，这个账户裡的「存款
                  」就会减少甚至再负债，因为我们从
                  账户裡提走了一笔，我们的存款就会 越少，很容易存款就会被提光。
                  所以，多为我们自己存一些存款 进去吧！这些存款（功德〉，可以帮
                  助我们将来事业顺利、婚姻美满、家 庭和乐……赶快存款吧！
                </p>

                <p class="project-description">
                  <span><b>第四章：冤亲债主 </b></span>
                  冤亲债主产生的原因： 骗人感情 骗人钱财 作姦犯科 杀人、偷盗
                  争遗产、兄弟姐妹失和 因奉养父母，子生怨 诽镑外人 多舌、生是非
                  这些人怀恨在心找机会找我们报 仇。
                  <span><b>冤亲债主是怎麽产生的？</b></span>
                  如果我们上辈子犯下一些恶行， 如杀生、偷盗、邪淫、妄语、骗话、
                  花舌、恶0、贪爱、憎恨、愚痴…… 这辈子除了要接受该有的恶报外，这
                  些事被我们伤害或伤心过的人，也会
                  找机会向我们报复，这些人，就是我 们的冤亲债主。 例如：
                  上辈子为了争遗产，为了争谁奉 养父母，结果兄弟变仇人。
                  上辈子喜欢东家长，西家短，害 得别人婚姻出现问题，家庭破碎。
                  上辈子任意徘镑人家，污衊人家 , 造摇生事〇
                  上辈子。骗了人家的感情，骗了人 家的钱，做出对不起人家的事……
                  <span><b>冤亲债主的种类</b></span>
                  冤亲债主 无形的 尚未投胎转世随时准备向我们报 复的人 有形的
                  已经投胎转世父母、兄弟、夫妻 冤亲债主分成两种：
                  一种是无形的：目前还未投胎转 世。 一种是有形的：已经投胎转世，
                  准备这辈子来向我们报恩报仇的。如 父子.兄弟.夫妻……
                  都是有形的冤亲债主。 所以，大解冤经说：
                  又或有人，每于前世，用诈用奸 ，假仁假义，施于朋友，欺侮愚昧，
                  今生乃得为弟昆。凡人昆季不和，自
                  相戕害，皆此因缘。又或有人，每于
                  行动，误伤生命，剋待妻妾，冤怨之
                  魂，今生仍为夫妇，或女转男，或男
                  转女，又寻报复，但有反目夫妻，皆 此因缘。
                  又或有人，用人不当，残忍待下 ，剥削奴僕，结为冤家，转世投生，
                  颠倒主僕，甘受欺凌。 所以「夫妻相欠债」、「父子相欠债
                  」……我们来到这世上，根本就是来
                  还债的。勤烧还债金是最简单的还债
                  方法。所以有人说：好的夫妻、兄弟 、父子前来报恩，坏的来讨债。
                </p>

                <p class="project-description">
                  <span
                    ><b>
                      第五章：根本解决之道
                    </b></span
                  >
                  (1)帮冤亲债主离苦得乐 很多人发生了事情，以为请神佛
                  帮忙就可以解决问题，这是不可能的
                  事，因为神佛是不可能帮你担罪的。 有些冤亲债主会因为神佛的介入
                  暂时不向您讨债，但这不代表他原谅
                  了您，只是他卖给神佛一个面子，暂
                  时放过您而已。等过了一阵子他在地
                  狱受气了，他又来向您讨债了，那时 候问题又发生了。
                  所以，要真的解决问题，就是要 冤亲债主离苦得乐，只有他们离苦得
                  乐了，您才能离苦得乐。 所以，我们一定要多唸经文、烧
                  还债金、做功德光迴向给冤亲债主。 一方面帮助他们早日放下，不再
                  生我们的气，一方面帮助他们早日得
                  到功果，可早日投胎转世或到西方极 乐世界
                  (2)没有比烧还债金、做功德更便宜 更容易的事了。
                  有些人可能会认为：要烧那麽多 还债金，要做那麽多功德给他们，真
                  的好辛苦呀！但如果仔细想一想，您
                  会发现，其实这是非常便宜的事。比
                  起这些冤亲债主让我们得奇难杂症，
                  让我们事业失败、让我们家庭出问题
                  ，让我们子女忤逆……只烧还债金、 做功德，不是太便宜太容易了吗？
                  所以，时常烧还债金、做功德给 这些冤亲债主吧！您会发现，您的阻
                  碍越来越少，您的事业越来越顺利，
                  您的婚姻越来越美满。这不就是「有 求必应」！ (3)阴阳两利
                  其实我们烧还债金、做功德光迴向 给冤亲债主，也是冥阳两利的事。
                  对冤亲债主来说：可以帮助他们离
                  苦得乐。对我们自己来说：可以帮助我们 做事越来越顺利。
                  <span><b>阴阳两利</b></span>
                  烧还债金、做功德阴阳两利 自己事事越来越如意！
                  冤亲债主离苦得乐！
                  <span><b>烧还债金 </b></span>
                  烧还债金、 积功德要诚虔 ，不需要指名给 谁。
                  「愿以此还债金迴向于累世历劫 、前世今生、冤亲债主、解冤解结」
                  只要您指名要替自己还的债？或 替家人还的债？您父母的债？您祖先
                  的冤亲债？每次烧时指明，那您的事
                  业就越来越顺利，求您的婚姻越来越
                  美满，只要您有每天诚心去做，您会 发现：心想慢慢就事成。
                  <span><b>说话的艺术 </b></span>
                  急事，慢慢地说！ 大事，清楚地说； 小事，幽默地说。
                  没把握的事，谨慎地说； 没发生的事，不要胡说。
                  做不到的事，别乱说。 伤害人的事，不能说。
                  讨厌的事，对事不对人地说。 开心的事，看场合说。
                  伤心的事，不要见人就说。 别人的事，小心地说；
                  自己的事，听听自己的心怎麽说。 现在的事，做了再说；
                  未来的事，过了再说。 如果我有失误的地方，请一定要 对我说！
                </p>

                <p class="project-description">
                  <span
                    ><b>
                      听命理师一席话 焚烧「还债金」+ 行善中头奖
                      王志财这时非常感谢那位命理师，开导他放生行善和
                      布施孤儿院以及焚烧「还债金」，没想到会让他中了 头奖。
                    </b></span
                  >
                  王志财今年45岁, 是一名建筑工友 I(俗称泥水工)。来自雪洲巴生。
                  王志财没有受过高深的教育，虽 然从名字的字义看来，其父取名时，
                  是希望志财长大后，能够立志赚多多
                  的钱，又或者做个有钱有势的人，安 居乐业。
                  可是王父的愿望可能落空了。 王志财从小便不大爱读书，所以
                  初中毕业后，便出来社会工作。王志
                  财没有文凭，很难觅得文工，唯一的
                  出路便是苦干，跟随做建筑的伯父做
                  泥水工人，没想到一做就就是廿二年 的光景。
                  有人用20年的岁月建立自己的事 业王朝, 王志财却用20年的光阴, 用
                  在建筑别人的屋子上，如此说来没有 功劳也有苦劳,
                  换取20年的温饱。
                  <span><b>建筑劳工</b></span>
                  王志财于25岁那年结婚, 迄今育 有二男一女、其长子今年亦快要高中
                  毕业了，小女唸初中，做建筑行能养 活一家五口，殊为不易。
                  这份卖苦力的行业，日晒雨淋， 操劳得要命，王志财的皮肤黝黑，看
                  上去比实际年龄苍老了一些，王志财
                  苦笑说：「干我们这行的，都是老粗 ，歹命一条，手停口停。」
                  俗语说：「吃得苦中苦，方为人王志财不敢自诩人上人，只求老
                  大爷赐一家五口三餐温饱，便心满意足了。 但人总有欲望。
                  王志财为人老实，没什么特殊的 嗜好，他的朋友常约他钓鱼或搓麻将
                  、玩荷兰牌。他都没什兴趣，连上云 顶都意兴阑珊。
                  很多人以为王志财是圣人，那就错了。
                  王志财只是个凡人，他虽不上云 顶，不钓鱼，却最喜欢买万字，而且
                  这样一来一买，竟然嗜玩了廿二年。 这廿二年来，王志财在投注万字
                  方面，确实输了不少钱，虽然投注额 不是很大, 一期约20元左右,
                  但少数 聚多, 一个月平均13期, 一年平均156
                  期，单是花费买万字输多赢少，一年
                  就雙掉三千元，廿二牵就龠掉将近七 万元。
                  <span><b>未中过大奖</b></span>
                  说起来也真可悲，问王志财有生 以来中最大的奖是多少，他回答说：
                  「六百大元」。 老天，这是典型的财帛超薄缘，
                  意思是说，从没有中过大奖，也可以 说没有横财运。
                  王志气财心有不甘，让一位命理 师批算他的横财运，命理师很率直的
                  告诉他：「您的命中没有横财命，还 是少赌为妙。」
                  王志财恳请命理师，问有无方法 中一些横财？命理师说，一个人的横
                  财运是与生具来的，一个人如果命中
                  没有横财命，表示其人前生少做善事 ，所以钱财的福报不大。
                  有些人，天生下来就是横财命， 在某一些特定的年份里，会时常中大
                  奖，财源滚滚来。 但大多数的人，都像王志财一样，
                  命中横财运不强，这也是大部份人的
                  宿命，所以没有嗜赌的人，无形中就
                  省下一笔钱，让生活过得比较写意思 王志财较庆幸的是投注额不大，
                  他不是「赌客亡命徒」，只是赌瘾戒
                  不掉，逢开彩日都要博一博运气，长 久下来，形成一种习惯。
                  <span><b>命理师指点迷津 </b></span>
                  命理师对王志财说：「要改善财 运的方法很多，只是看那一项方法比
                  较适合自己。 命理建议王志财多做善事、第一件
                  要学习的就是行善。行善必须身体力
                  行，有力出力、有钱出钱，如果能出
                  钱又出力，那是行善的増上缘。行善
                  可以是捐钱给福利机构、譬如残缺儿
                  童、孤儿院或老人院；现在有许多洗
                  肾中心极需大众的捐献，为患肾病者 提供洗肾的服务。
                  做义工也是很有福报的善举，凭 自己的一份热忱、效劳卖力、绝无怨
                  言。这种任劳任怨的美德，其实也是
                  身心的修养，可以提高自己的品性，
                  这是一举两得的，即可协助需要的人
                  尽一份棉力、又可增加自己的福报。 命理师说，要行善必须持之以恒
                  ，也不可以抱着三分钟热度，并凭自
                  己的能力，无私的奉献，最重要的是 量力而为。
                  这是一种行善的布施行为，凡是 有能力的人，都受鼓励这么做，而且
                  所得的福报，常有令人意想不到的惊 喜。
                  命理师说，如果行善在加焚烧「 还债金」给冤亲债主
                  ，会有意想不到的（好运）。王志远听了命理师的一席话后，便买了
                  20只小 鸟，到家附近的树林放生；接着携妻
                  带子，买了一些粮食和家庭日常用品
                  ,到附近的孤儿院派送。然后焚烧了 八盒「还债金」给冤亲债主。
                  王志财第一次经验行善布施时， 心理充满了喜悦和感动，
                  他觉得施舍实在是一种无比的快乐，
                  连孩子都说：「爸爸，我们以后要多
                  做善事，看到孤儿们这么可怜，才知 道自己是多么的幸福。」
                  <span><b>放生行善+焚烧「还债金」 </b></span>
                  王志财听到孩子们说的话，心理 感动不已。他没想到，第一次布施会
                  让孩子们这么感动，更下定决心，以 后要多做善事。
                  然而，意想不到的事情发生了。 二零零八年二月十七日〔星期天
                  〕上午十时，王志财夫妇到巴刹买了
                  十多条的泥鳅，到附近的大湖，与孩
                  子们一起放生后，回程经过多多投注站 〇
                  王志财突然觉得心血来潮、停下 车、下注自己的车牌3699、包一元大
                  万（等于下注十二元〕。王志财平时都喜欢在万能下注，
                  这次经过“丨〇投注站，随缘下注多多 博彩，这是非常少有的现象。
                  王志财本身也有些愕然，惊讶自 己怎会到化1〇投注站, 不过他也没放
                  在心上，载妻儿到一家茶室用餐。 晚上七时四十五分，王志财接到
                  手机传来的开彩成绩，最先传来的是
                  万能，接着是大马彩。由于王志财没
                  有投注万能和大马彩，看了就搁在一旁
                  最后传来的成绩是多多博彩，王 志财起先没什么在意，过后才发觉开
                  头奖的9639很熟, 他中了包字3699头 奖，整个人开心的跳起来。
                  这是王志财赌万字廿二年来，第 一次中头奖，这种忘我的兴奋与喜悦
                  ，让全家人都沸腾起来。 王志财高兴地大喊：「我终于中
                  头:奖了！」 王志财这时非常感谢那位命理师
                  ，开导他放生行善和布施孤儿院以及
                  焚烧「还债金」，没想到会让他中了 头奖。
                  这种愉快的中奖经验，让王志财 兴奋莫名，从此更勤于行善、放生，
                  也介绍朋友们多多使用「还债金」焚 烧给冤亲债主，希望 能让
                  更多的人仿效， 从中受惠。
                </p>

                <p class="project-description">
                  <span><b>※如何使用還債金： </b></span>
                  有人戲稱焚燒還債金是賄賂神明之舉，實際是誤解了，宗教家視焚燒還債金是一種還心願之禮，而祭神鬼時先焚香祷告後焚燒還債金是「轉化磁場」，這是出於祭禮上信徒虔敬的心意，豈容曲解還債金為賄賂神鬼之物。
                  ※如何為自己還前世之債焚燒還債金：
                  祭品：依個人慣例準備牲禮或敬果、餅品或各種素齋等，若準備牲禮須另備有酒須三杯，需敬三次。
                  還債金數量依個人心意決定，一般為自己還債要多加一些。不過，必須將姓名填上內付的紅紙表格內。當天敬拜，焚燒在家中的神前或天神前。
                  焚燒還債金可還前世之債，當還清前世之債時，除了前世和陰間宿怨消除，正所謂無債一身輕，做起事來就會得心應手。
                  <span><b>※如何拜祖先： </b></span>
                  祭品：依個人慣例，準備供奉菜品，焚燒時口諗：今日是何日何時，請祖先們皆回來用食。过後在祖先前焚燒還債金。這裡焚燒還債金是替先人還債，讓先人不必為前世的債務糾纏不清，無法抽空出來照顧陽間子孫。如果先人前世債務太多，他們也會請求陽間子孫幫忙，這樣就會使到陽間子孫陰氣太重，或者沾到陰氣。替先人焚燒還債金還債就能得到先人的助力。
                  <span><b>※如何焚燒還債金拜孤魂野鬼（好兄弟）： </b></span>
                  祭品：依慣例準備葷、素均菜品均可，量以個人誠意為之。在一柱香過三分之二時才焚燒還債金。這時焚燒還債金不必填寫什麼，只要諗諗好兄弟即可。除可協助孤魂野鬼（好兄弟）容易轉世投胎再世為人，自己也會得到來自（好兄弟）的一份助力，增加貴人運和財運。
                  <span><b>※如何拜地主公： </b></span>
                  祭品：依慣例準備，下午二點後祭拜，上午祈願時須朝內而拜。
                  時間：一柱香過五分之一時燒還債金，燒還債金時口諗焚燒給地主公即可。焚燒還債金給地主公，除了出入平安，還可以增加財富。在清明時刻焚燒還債金給地主公，助力會比平時增強
                  <span><b>※如何掃墓用還債金： </b></span>
                  祭品：準備葷、素菜品、還債金。焚燒還債金時口中要諗是燒給誰。
                  這可讓亡人在投胎轉世為人，不必受到債務纏身之苦。自己也得到更多的助力。
                  为子孙增加财运。
                </p>
              </div>
              <!-- /.project-description -->
            </aside>
          </div>
        </div>
      </section>
      <!-- /.section-project -->

      <RelatedProduct productCode="huan-zai-jin" />
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "../partials/NavBar.vue";
import Footer from "../partials/Footer.vue";
import RelatedProduct from "./RelatedProduct.vue";

export default {
  name: "HuanZaiJin",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
    RelatedProduct
  },
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/HuanZaiJin.vue